import { API_PATH } from '../../constants';
import { encodeQueryParams } from '../../utils/query-params';

export const constructURL = (apiEndpoint, ids, params) => {
  let url = `${API_PATH}/${apiEndpoint}`;
  params = params || {};
  // delete keys with undefined values
  for (const [k, v] of Object.entries(params)) (v === null || v === undefined) && delete params[k];

  url = replaceParameters(url, params);

  if (ids.length > 0) {
    const idQuery = Array.isArray(ids) ? ids.join(',') : ids;
    if (apiEndpoint.includes('{id}')) {
      if (ids.length > 1) {
        throw new Error('Thou shalt not pass an array if {id} is part of the URL');
      }
      url = url.replace('{id}', ids);
    } else {
      params.ids = idQuery;
    }
  }
  if (Object.keys(params).length > 0) {
    const queryString = encodeQueryParams(params);
    url = `${url}?${queryString}`;
  }

  return url;
};

export const replaceParameters = (url, params) => {
  let result = url;
  const matches = url.match(/\{.*\}/) || [];
  for (const match of matches) {
    const attributeName = match.substring(1, match.length - 1);
    if (params[attributeName] === undefined) continue;
    result = url.replace(match, params[attributeName]);
    delete params[attributeName];
  }
  return result;
};
